import { render, staticRenderFns } from "./besonderheiten.vue?vue&type=template&id=5aaa3d1e&scoped=true"
import script from "./besonderheiten.vue?vue&type=script&lang=js"
export * from "./besonderheiten.vue?vue&type=script&lang=js"
import style0 from "./besonderheiten.vue?vue&type=style&index=0&id=5aaa3d1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaa3d1e",
  null
  
)

export default component.exports